var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-gutters"},[_c('Sidebar'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"nuxt-wrapper container-fluid"},[_c('nuxt')],1)]),_vm._v(" "),_c('AppDrawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }